import { render, staticRenderFns } from "./mediniDialog.vue?vue&type=template&id=cc0505d4&"
import script from "./mediniDialog.vue?vue&type=script&lang=js&"
export * from "./mediniDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports